import { inject, Injectable } from "@angular/core";
import { BusinessDayCalculatorPL, IKsefDeadlineDateCalculator, isDocumentToKsef } from "@skylab-shared/business";
import { KsefSendSubmissionMode } from "@skylab-shared/dataModel";
import { KsefMonitorService } from "./ksef-monitor.service";

const KSEF_OFFLINE_SUBMISSION_DAYS_LIMIT = {
	OFFLINE: 1,
    EMERGENCY: 7
};

@Injectable({providedIn: 'root'})
export class KsefDeadlineDateCalculator implements IKsefDeadlineDateCalculator {
    readonly #ksefMonitor = inject(KsefMonitorService);

    calculate(ksefSubmissionMode: KsefSendSubmissionMode, issueDate: Date): Date | null {
        if (!isDocumentToKsef({ksefSubmissionMode}) || !issueDate) return null;

        const map: Record<KsefSendSubmissionMode, Date | null> = {
            [KsefSendSubmissionMode.None]: null,
            [KsefSendSubmissionMode.Online]: new Date(issueDate),
            [KsefSendSubmissionMode.Offline]: BusinessDayCalculatorPL.addBusinessDays(issueDate, KSEF_OFFLINE_SUBMISSION_DAYS_LIMIT.OFFLINE),
            [KsefSendSubmissionMode.Emergency]: BusinessDayCalculatorPL.addBusinessDays(issueDate, KSEF_OFFLINE_SUBMISSION_DAYS_LIMIT.EMERGENCY),
        }

        return map[ksefSubmissionMode] ?? null;
    };
}